import React from 'react'
import { Layout } from './Layout'
import { Provider } from './Context'

export const BankPanel = () => {
  return (
    <Provider>
      <Layout />
    </Provider>
  )
}
